import React from 'react'
import classnames from 'classnames'

export interface SortIndicatorProps {
  active: boolean
  direction: 'asc' | 'desc'
  className?: string
}

/** Stacked up/down chevrons; active direction highlighted in indigo. */
export const SortIndicator: React.FC<SortIndicatorProps> = ({ active, direction, className }) => {
  const inactive = 'text-slate-300 dark:text-slate-600'
  const highlight = 'text-indigo-600 dark:text-indigo-400'
  const upClass = active && direction === 'asc' ? highlight : inactive
  const downClass = active && direction === 'desc' ? highlight : inactive

  return (
    <span className={classnames('inline-flex shrink-0 flex-col gap-0.5 leading-none', className)} aria-hidden>
      <svg viewBox="0 0 12 6" className={classnames('h-1.5 w-2.5', upClass)}>
        <path fill="currentColor" d="M6 0 12 6H0Z" />
      </svg>
      <svg viewBox="0 0 12 6" className={classnames('h-1.5 w-2.5', downClass)}>
        <path fill="currentColor" d="M6 6 0 0h12Z" />
      </svg>
    </span>
  )
}

export interface SortHeaderButtonProps {
  label: React.ReactNode
  active: boolean
  direction: 'asc' | 'desc'
  onClick: () => void
  align?: 'left' | 'right' | 'center'
  className?: string
}

/** Sortable column header: stacked sort icon always left of the label. */
export const SortHeaderButton: React.FC<SortHeaderButtonProps> = ({
  label,
  active,
  direction,
  onClick,
  align = 'left',
  className
}) => (
  <button
    type="button"
    onClick={onClick}
    className={classnames(
      'inline-flex items-center gap-1.5 font-medium hover:text-slate-700 dark:hover:text-slate-200',
      align === 'right' && 'ml-auto',
      align === 'center' && 'mx-auto',
      active && 'text-slate-700 dark:text-slate-200',
      className
    )}
  >
    <SortIndicator active={active} direction={direction} />
    {label}
  </button>
)

export default SortHeaderButton
